import { FileResult } from '../../components_v2/input/model/Model';
import { confirmFileManagerPost, postFileManagerGetUrl, postToS3 } from './actions';

export async function uploadFile(file: FileResult, currentPath: string): Promise<string> {
	const res = await postFileManagerGetUrl();
	await postToS3(res.url, file);
	await confirmFileManagerPost({ path: (currentPath + file.file.name), filesize: file.file.size, uuid: res.uuid });
	return 'ok';
}
